import {PropsWithChildren} from 'react';
import {Navigate, Route, Routes} from 'react-router-dom';

import {FeatureFlags} from 'core/constants/featureFlags';
import {ENNABL_AI_MIGRATION} from 'core/constants/paths';
import {useFeatureFlag, useIsInternalUser} from 'core/hooks/authHooks';
import {lazyLoad} from 'utils/lazyLoadUtils';

import {LoadingScreen} from 'components/LoadingScreen';

const EnnablAIMigrationPage = lazyLoad(
  () =>
    import(/* webpackChunkName:'ennabl-ai-migration-page' */ 'pages/EnnablAIMigrationPage').then(m => ({
      default: m.EnnablAIMigrationPage,
    })),
  {fallback: <LoadingScreen />}
);

/**
 * When the DISABLE_DECISIONS flag is on, Decisions is retired for the tenant —
 * every route redirects to the ennablAI migration page.
 *
 * internal users keep access to every route regardless of the flag.
 */
export const DecisionsDisabledGate = ({children}: PropsWithChildren) => {
  const withDecisionsDisabled = useFeatureFlag(FeatureFlags.DisableDecisions);
  const isInternalUser = useIsInternalUser();

  if (!withDecisionsDisabled || isInternalUser) {
    return <>{children}</>;
  }

  return (
    <Routes>
      <Route path={ENNABL_AI_MIGRATION} element={<EnnablAIMigrationPage />} />
      <Route path='*' element={<Navigate replace to={ENNABL_AI_MIGRATION} />} />
    </Routes>
  );
};
